import React from 'react';
import { Box, Text, Link, Stack, Icon } from '@chakra-ui/react';
import { HelpCircle } from 'lucide-react';


function handleCrispChatToggle(e) {
    e.preventDefault();
    if (window.$crisp && typeof window.$crisp.push === 'function') {
        window.$crisp.push(["do", "chat:toggle"]);
    }
}

const NeedHelpSettingUp = () => (
    <Box display="flex" alignItems="center" bg="gray.50" borderRadius="md" p={3} mt={4}>
        <Icon as={HelpCircle} color="gray.400" boxSize={6} mr={2} />
        <Stack direction="row" alignItems="center" spacing={2}>
            <Text fontWeight="medium" color="gray.700" fontSize="sm">
                Need help setting up?
            </Text>
            <Text color="gray.400" fontSize="xs">
                Our team is available
            </Text>
            <Link
                color="purple.500"
                fontWeight="semibold"
                fontSize="sm"
                href="#"
                onClick={handleCrispChatToggle}
            >
                Get Assistance
            </Link>
        </Stack>
    </Box>
);

export default NeedHelpSettingUp;
